// Helper function to get a relevant topic placeholder based on the selected subject
export function getTopicPlaceholder(subject) {
  switch (subject) {
    case 'Mathematics':
      return 'e.g., Fractions, Algebra, Calculus, Geometry';
    case 'Science':
      return 'e.g., Scientific Method, States of Matter, Energy';
    case 'Biology':
      return 'e.g., Photosynthesis, Human Body Systems, Genetics';
    case 'Chemistry':
      return 'e.g., Periodic Table, Chemical Reactions, Acids and Bases';
    case 'Physics':
      return 'e.g., Forces and Motion, Electricity, Waves';
    case 'English':
      return 'e.g., Grammar, Writing Process, Reading Comprehension';
    case 'Literature':
      return 'e.g., Shakespeare, Poetry Analysis, Novel Studies';
    case 'History':
      return 'e.g., Ancient Civilisations, World Wars, Civil Rights Movement';
    case 'SocialStudies':
      return 'e.g., Government, Citizenship, Cultural Studies';
    case 'Geography':
      return 'e.g., Map Skills, Climate Zones, Human Geography';
    case 'ComputerScience':
      return 'e.g., Coding, Algorithms, Web Development';
    case 'DesignTechnology':
      return 'e.g., Product Design, CAD, Sustainable Materials';
    case 'ForeignLanguages':
      return 'e.g., Verb Tenses, Vocabulary Building, Cultural Practices';
    case 'Art':
      return 'e.g., Colour Theory, Art History, Specific Techniques';
    case 'Music':
      return 'e.g., Music Theory, Instrument Instruction, Music History';
    case 'PhysicalEducation':
      return 'e.g., Team Sports, Fitness Concepts, Motor Skills';
    case 'Economics':
      return 'e.g., Supply and Demand, Economic Systems, Financial Literacy';
    case 'Psychology':
      return 'e.g., Human Development, Mental Health, Research Methods';
    case 'Philosophy':
      return 'e.g., Ethics, Logic, Philosophical Movements';
    case 'custom':
      return 'Enter a specific topic within your custom subject';
    default:
      return 'e.g., Photosynthesis, World War II, Algebra';
  }
}